export const SERVICE_OPTIONS = [
  'PDPA Pro',
  'Cookie Wow',
  'PDPA Form',
  'PDPA Prokit',
  'LearnPDPA',
  'PDPA Core (PDPA Implementation)',
] as const
